import { render, staticRenderFns } from "./position.vue?vue&type=template&id=4c9bed77"
import script from "./position.vue?vue&type=script&lang=js"
export * from "./position.vue?vue&type=script&lang=js"
import style0 from "./position.vue?vue&type=style&index=0&id=4c9bed77&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports